import {Cureus} from '../Cureus';

Cureus.Boost = {}
//= require_tree ./Boost